<template>
  <JqxWindow ref="myWindow" :theme="'material'" :width="400" :height="250" :resizable="true" :isModal="true"
             :autoOpen="false">
    <div class="col-md"><strong>Picking</strong>
    </div>
    <div>
      <div style="margin-top: 5px;margin-left: 5px;">
        <div class="form-group">
          <label>Descrizione</label>
          <br>
          <JqxInput :theme="'material'" ref="descrizione"></JqxInput>
        </div>
        <div class="form-group">
          <label>Note</label>
          <br>
          <JqxInput :theme="'material'" ref="note"></JqxInput>
        </div>
      </div>
      <card>
        <div class="float-right">
          <JqxButton :theme="'material'" @click="saveParent">
            Save
          </JqxButton>

          <JqxButton :theme="'material'" @click="cancelParent">
            Cancel
          </JqxButton>
        </div>
      </card>
    </div>
  </JqxWindow>
</template>

<script>

  import JqxWindow from "~jqx/jqwidgets-vue/vue_jqxwindow.vue";
  import JqxButton from "~jqx/jqwidgets-vue/vue_jqxbuttons.vue";
  import JqxInput from "~jqx/jqwidgets-vue/vue_jqxinput.vue";
  import JqxNumberInput from "~jqx/jqwidgets-vue/vue_jqxnumberinput.vue";
  import JqxCheckBox from "~jqx/jqwidgets-vue/vue_jqxcheckbox.vue";

  export default {
    name: "PickingDetails",
    components: {
      JqxInput,
      JqxNumberInput,
      JqxButton,
      JqxWindow,
      JqxCheckBox
    },
    data: function () {
      return {
      }
    },
    methods: {
      saveParent() {
        this.$parent.saveBtn();
      },
      cancelParent() {
        this.$parent.cancelBtn();
      },
    }
  }
</script>

<style scoped>
  .jqx-splitter {
    border: none;
  }
</style>
